"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AreaCrimeWrapper$ = exports.AreaCrimeWrapper$outboundSchema = exports.AreaCrimeWrapper$inboundSchema = void 0;
exports.areaCrimeWrapperToJSON = areaCrimeWrapperToJSON;
exports.areaCrimeWrapperFromJSON = areaCrimeWrapperFromJSON;
const z = __importStar(require("zod"));
const schemas_js_1 = require("../../../lib/schemas.js");
const areacrime_js_1 = require("./areacrime.js");
/** @internal */
exports.AreaCrimeWrapper$inboundSchema = z.object({
    attributes: areacrime_js_1.AreaCrime$inboundSchema,
    id: z.string(),
});
/** @internal */
exports.AreaCrimeWrapper$outboundSchema = z.object({
    attributes: areacrime_js_1.AreaCrime$outboundSchema,
    id: z.string(),
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var AreaCrimeWrapper$;
(function (AreaCrimeWrapper$) {
    /** @deprecated use `AreaCrimeWrapper$inboundSchema` instead. */
    AreaCrimeWrapper$.inboundSchema = exports.AreaCrimeWrapper$inboundSchema;
    /** @deprecated use `AreaCrimeWrapper$outboundSchema` instead. */
    AreaCrimeWrapper$.outboundSchema = exports.AreaCrimeWrapper$outboundSchema;
})(AreaCrimeWrapper$ || (exports.AreaCrimeWrapper$ = AreaCrimeWrapper$ = {}));
function areaCrimeWrapperToJSON(areaCrimeWrapper) {
    return JSON.stringify(exports.AreaCrimeWrapper$outboundSchema.parse(areaCrimeWrapper));
}
function areaCrimeWrapperFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.AreaCrimeWrapper$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'AreaCrimeWrapper' from JSON`);
}
//# sourceMappingURL=areacrimewrapper.js.map